import { ca } from '@cian/analytics';

export function trackInfrastructureItemClick(objectType?: string) {
  ca('eventSite', {
    action: 'click_object_type',
    category: 'Infrastructure',
    label: objectType,
    name: 'oldevent',
    useLastProducts: true,
  });
}
